// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Content Strategy Simplified Report Styles */
:root,
.cs-report-root,
.cs-modal-card {
  --navy: #14132b;
  --navy-2: #1d1b3b;
  --navy-border: #302e54;
  --teal: #22c9a0;
  --teal-dark: #087f67;
  --teal-soft: #e6f9f4;
  --red: #c53b4a;
  --red-soft: #fff0f2;
  --amber: #a96c00;
  --amber-soft: #fff7e7;
  --blue: #315fba;
  --blue-soft: #eef4ff;
  --ink: #1d1c2e;
  --muted: #68677c;
  --quiet: #9291a3;
  --line: #e3e3ed;
  --surface: #fff;
  --canvas: #f6f6fa;
  --radius: 12px;
  --shadow: 0 18px 50px rgba(20, 19, 43, 0.16);
}

.cs-report-root,
.cs-modal-card {
  font-family: Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #1d1c2e;
  color: var(--ink);
}

.cs-report-root {
  width: 100%;
}

.cs-report-root *,
.cs-modal-card * {
  box-sizing: border-box;
}

.cs-report-main {
  padding: 8px 0 60px;
}

.cs-report-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 18px;
}

.cs-report-header h1 {
  margin: 0 0 7px;
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 800;
  letter-spacing: -0.035em;
  color: #1d1c2e;
  color: var(--ink);
}

.cs-lede {
  max-width: 690px;
  margin: 0;
  color: #68677c;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.55;
}

.cs-status {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 12px;
  border-radius: 999px;
  color: #087f67;
  color: var(--teal-dark);
  background: #e6f9f4;
  background: var(--teal-soft);
  font-size: 12px;
  font-weight: 750;
}

.cs-status::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c9a0;
  background: var(--teal);
}

/* Run Card */
.cs-run-card {
  display: grid;
  grid-template-columns: 1.15fr 1.85fr auto;
  align-items: center;
  grid-gap: 22px;
  gap: 22px;
  padding: 16px 18px;
  border: 1px solid #e3e3ed;
  border: 1px solid var(--line);
  border-radius: 12px;
  border-radius: var(--radius);
  background: #fff;
  background: var(--surface);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.cs-run-item + .cs-run-item {
  border-left: 1px solid #e3e3ed;
  border-left: 1px solid var(--line);
  padding-left: 22px;
}

.cs-eyebrow {
  margin-bottom: 5px;
  color: #9291a3;
  color: var(--quiet);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.cs-run-value {
  font-size: 13px;
  font-weight: 700;
  color: #1d1c2e;
  color: var(--ink);
}

.cs-competitors {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.cs-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border: 1px solid #e3e3ed;
  border: 1px solid var(--line);
  border-radius: 6px;
  color: #68677c;
  color: var(--muted);
  background: #f9f9fc;
  font-size: 11px;
  font-weight: 650;
}

.cs-run-time {
  color: #68677c;
  color: var(--muted);
  font-size: 12px;
  white-space: nowrap;
}

/* Sections */
.cs-section {
  margin-top: 34px;
  scroll-margin-top: 20px;
}

.cs-section-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 20px;
  margin-bottom: 13px;
}

.cs-section-title {
  display: flex;
  align-items: center;
  gap: 9px;
}

.cs-section-title h2 {
  margin: 0;
  font-size: 19px;
  font-weight: 750;
  letter-spacing: -0.02em;
  color: #1d1c2e;
  color: var(--ink);
}

.cs-count {
  padding: 3px 8px;
  border-radius: 999px;
  color: #68677c;
  color: var(--muted);
  background: #ebebf2;
  font-size: 11px;
  font-weight: 750;
}

.cs-section-copy {
  margin: 4px 0 0;
  color: #68677c;
  color: var(--muted);
  font-size: 13px;
}

.cs-section-note {
  max-width: 290px;
  color: #9291a3;
  color: var(--quiet);
  font-size: 11px;
  text-align: right;
  line-height: 1.45;
}

/* Lists and Cards */
.cs-gap-list,
.cs-opportunity-list {
  display: grid;
  grid-gap: 12px;
  gap: 12px;
}

.cs-card {
  border: 1px solid #e3e3ed;
  border: 1px solid var(--line);
  border-radius: 12px;
  border-radius: var(--radius);
  background: #fff;
  background: var(--surface);
  overflow: hidden;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.cs-card:hover {
  border-color: #d0d0e0;
}

/* Gap Details & Summary */
.cs-gap-summary {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) auto;
  align-items: center;
  grid-gap: 13px;
  gap: 13px;
  padding: 17px 18px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.cs-gap-summary:hover {
  background-color: #fafafd;
}

.cs-index {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #c53b4a;
  color: var(--red);
  background: #fff0f2;
  background: var(--red-soft);
  font-size: 11px;
  font-weight: 850;
}

.cs-gap-title {
  margin: 0 0 5px;
  font-size: 14px;
  font-weight: 750;
  color: #1d1c2e;
  color: var(--ink);
}

.cs-gap-issue {
  margin: 0;
  color: #68677c;
  color: var(--muted);
  font-size: 12.5px;
  line-height: 1.5;
}

.cs-summary-side {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cs-severity {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.cs-severity.high {
  color: #c53b4a;
  color: var(--red);
  background: #fff0f2;
  background: var(--red-soft);
}

.cs-severity.medium {
  color: #a96c00;
  color: var(--amber);
  background: #fff7e7;
  background: var(--amber-soft);
}

.cs-severity.low {
  color: #087f67;
  color: var(--teal-dark);
  background: #e6f9f4;
  background: var(--teal-soft);
}

.cs-chevron {
  color: #9291a3;
  color: var(--quiet);
  font-size: 16px;
  transition: transform 0.18s ease;
  display: inline-block;
}

.cs-chevron.open {
  transform: rotate(180deg);
}

.cs-gap-body {
  padding: 0 18px 18px 67px;
  border-top: 1px solid #e3e3ed;
  border-top: 1px solid var(--line);
}

.cs-compare-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  gap: 10px;
  margin: 15px 0;
}

.cs-compare {
  min-width: 0;
  padding: 13px 14px;
  border: 1px solid #e3e3ed;
  border: 1px solid var(--line);
  border-radius: 9px;
  background: #fafafd;
}

.cs-compare.competitor {
  border-color: #bdeadd;
  background: #f2fcf9;
}

.cs-compare-label {
  margin-bottom: 7px;
  color: #9291a3;
  color: var(--quiet);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.cs-page-link {
  display: block;
  overflow: hidden;
  margin-bottom: 7px;
  color: #315fba;
  color: var(--blue);
  font-size: 11px;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

.cs-page-link:hover {
  text-decoration: underline;
}

.cs-compare p {
  margin: 0;
  color: #424156;
  font-size: 12.5px;
  line-height: 1.55;
}

.cs-finding {
  display: grid;
  grid-template-columns: 92px 1fr;
  grid-gap: 12px;
  gap: 12px;
  margin-top: 10px;
  font-size: 12.5px;
  line-height: 1.55;
}

.cs-finding b {
  color: #68677c;
  color: var(--muted);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.cs-finding span {
  color: #1d1c2e;
  color: var(--ink);
}

.cs-addressed {
  margin-top: 14px;
  padding-top: 13px;
  border-top: 1px dashed #e3e3ed;
  border-top: 1px dashed var(--line);
  color: #087f67;
  color: var(--teal-dark);
  font-size: 11.5px;
  font-weight: 700;
}

/* Opportunities */
.cs-opportunity {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  grid-gap: 14px;
  gap: 14px;
  align-items: start;
  padding: 18px;
}

.cs-opportunity .cs-index {
  color: #087f67;
  color: var(--teal-dark);
  background: #e6f9f4;
  background: var(--teal-soft);
}

.cs-opportunity h3 {
  margin: 1px 0 6px;
  font-size: 15px;
  font-weight: 750;
  line-height: 1.35;
  color: #1d1c2e;
  color: var(--ink);
}

.cs-type-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 9px;
}

.cs-type {
  padding: 3px 7px;
  border-radius: 5px;
  color: #315fba;
  color: var(--blue);
  background: #eef4ff;
  background: var(--blue-soft);
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.cs-type.update {
  color: #a96c00;
  color: var(--amber);
  background: #fff7e7;
  background: var(--amber-soft);
}

.cs-type.blog {
  color: #7651b5;
  background: #f3effb;
}

.cs-impact {
  padding: 3px 7px;
  border-radius: 5px;
  color: #68677c;
  color: var(--muted);
  background: #f1f1f6;
  font-size: 10px;
  font-weight: 750;
}

.cs-opportunity p {
  margin: 0;
  max-width: 650px;
  color: #68677c;
  color: var(--muted);
  font-size: 12.5px;
  line-height: 1.55;
}

.cs-gap-links {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 11px;
}

.cs-gap-ref {
  color: #087f67;
  color: var(--teal-dark);
  font-size: 11px;
  font-weight: 700;
}

.cs-action {
  align-self: center;
  min-width: 142px;
  padding: 9px 14px;
  border: 1px solid #14132b;
  border: 1px solid var(--navy);
  border-radius: 8px;
  color: #fff;
  background: #14132b;
  background: var(--navy);
  cursor: pointer;
  font-size: 12px;
  font-weight: 750;
  text-align: center;
  transition: transform 0.15s ease, background-color 0.15s ease, opacity 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.cs-action:hover {
  transform: translateY(-1px);
  background: #1d1b3b;
  background: var(--navy-2);
}

.cs-action:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.cs-action.secondary {
  color: #14132b;
  color: var(--navy);
  background: #fff;
  border-color: #d0d0e0;
}

.cs-action.secondary:hover {
  background: #f6f6fa;
  border-color: #14132b;
  border-color: var(--navy);
}

/* Change Panel */
.cs-change-panel {
  display: none;
  grid-column: 2 / -1;
  margin-top: 8px;
  padding: 14px;
  border-radius: 9px;
  background: #f9f9fc;
}

.cs-change-panel.show {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 11px;
  gap: 11px;
}

.cs-change {
  padding: 11px;
  border: 1px solid #e3e3ed;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #fff;
}

.cs-change b {
  display: block;
  margin-bottom: 5px;
  color: #9291a3;
  color: var(--quiet);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 800;
}

.cs-change span {
  font-size: 12px;
  line-height: 1.45;
  color: #1d1c2e;
  color: var(--ink);
  word-break: break-word;
}

/* AI Page Plan Modal Dialog */
.cs-modal-card {
  width: 100%;
  background: #fff;
  color: #1d1c2e;
  color: var(--ink);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.cs-modal-head {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  padding: 20px 22px 15px;
  border-bottom: 1px solid #e3e3ed;
  background: #fff;
}

.cs-modal-head h3 {
  margin: 4px 0 5px;
  font-size: 19px;
  font-weight: 750;
  color: #1d1c2e;
  color: var(--ink);
}

.cs-modal-head p {
  margin: 0;
  color: #68677c;
  color: var(--muted);
  font-size: 12px;
}

.cs-modal-btn {
  height: 32px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 11px;
  border: 0;
  border-radius: 8px;
  color: #68677c;
  color: var(--muted);
  background: #f1f1f6;
  cursor: pointer;
  font-size: 12px;
  font-weight: 650;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.cs-modal-btn:hover {
  background: #e2e2ec;
  color: #1d1c2e;
  color: var(--ink);
}

.cs-close-btn {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  color: #68677c;
  color: var(--muted);
  background: #f1f1f6;
  cursor: pointer;
  font-size: 18px;
  display: grid;
  place-items: center;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.cs-close-btn:hover {
  background: #e2e2ec;
  color: #1d1c2e;
  color: var(--ink);
}

.cs-modal-body {
  padding: 20px 22px 24px;
  overflow-y: auto;
  max-height: calc(100vh - 140px);
}

.cs-loading-state {
  min-height: 280px;
  display: grid;
  place-items: center;
  text-align: center;
  color: #68677c;
  color: var(--muted);
  font-size: 13px;
  padding: 20px;
}

.cs-spinner {
  width: 32px;
  height: 32px;
  margin: 0 auto 14px;
  border: 3px solid #e5e4ee;
  border-top-color: #22c9a0;
  border-top-color: var(--teal);
  border-radius: 50%;
  animation: csSpin 0.8s linear infinite;
}

@keyframes csSpin {
  to {
    transform: rotate(360deg);
  }
}

.cs-plan-overview {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  gap: 10px;
  margin-bottom: 20px;
}

.cs-plan-box {
  padding: 12px 13px;
  border: 1px solid #e3e3ed;
  border: 1px solid var(--line);
  border-radius: 9px;
  background: #fafafd;
}

.cs-plan-box b,
.cs-plan-section > b {
  display: block;
  margin-bottom: 5px;
  color: #9291a3;
  color: var(--quiet);
  font-size: 10px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  font-weight: 800;
}

.cs-plan-box span {
  font-size: 12.5px;
  line-height: 1.45;
  color: #1d1c2e;
  color: var(--ink);
}

.cs-plan-section {
  margin-top: 20px;
}

.cs-wireframe {
  display: grid;
  grid-gap: 9px;
  gap: 9px;
  margin-top: 10px;
}

.cs-wire-row {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  grid-gap: 11px;
  gap: 11px;
  padding: 14px;
  border: 1px solid #e3e3ed;
  border: 1px solid var(--line);
  border-radius: 9px;
  background: #fff;
}

.cs-wire-num {
  width: 27px;
  height: 27px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  color: #087f67;
  color: var(--teal-dark);
  background: #e6f9f4;
  background: var(--teal-soft);
  font-size: 11px;
  font-weight: 800;
}

.cs-wire-row h4 {
  margin: 0 0 5px;
  font-size: 13px;
  font-weight: 750;
  color: #1d1c2e;
  color: var(--ink);
}

.cs-wire-row p {
  margin: 0;
  color: #68677c;
  color: var(--muted);
  font-size: 11.5px;
  line-height: 1.5;
}

.cs-key-points {
  margin: 10px 0 0;
  padding-left: 18px;
  list-style: disc !important;
  list-style-type: disc !important;
}

.cs-key-points li {
  margin-bottom: 5px;
  color: #1d1c2e;
  color: var(--ink);
  font-size: 11.5px;
  line-height: 1.45;
  display: list-item !important;
  list-style: disc !important;
  list-style-type: disc !important;
}

.cs-section-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 8px;
  gap: 8px;
  margin-top: 11px;
}

.cs-section-detail {
  padding: 9px 10px;
  border-radius: 8px;
  background: #f7f7fa;
}

.cs-section-detail b {
  display: block;
  margin-bottom: 4px;
  color: #9291a3;
  color: var(--quiet);
  font-size: 9px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  font-weight: 800;
}

.cs-section-detail span {
  display: block;
  color: #68677c;
  color: var(--muted);
  font-size: 10.5px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.cs-guidance-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  gap: 10px;
}

.cs-guidance-grid ul {
  margin: 6px 0 0;
  padding-left: 17px;
  list-style: disc !important;
  list-style-type: disc !important;
}

.cs-guidance-grid li {
  margin-bottom: 6px;
  color: #68677c;
  color: var(--muted);
  font-size: 11.5px;
  line-height: 1.45;
  display: list-item !important;
  list-style: disc !important;
  list-style-type: disc !important;
}

.cs-internal-links {
  display: grid;
  grid-gap: 7px;
  gap: 7px;
  margin-top: 10px;
}

.cs-internal-link {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-gap: 12px;
  gap: 12px;
  align-items: center;
  padding: 10px 11px;
  border: 1px solid #e3e3ed;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #fff;
}

.cs-internal-link strong {
  font-size: 11.5px;
  color: #1d1c2e;
  color: var(--ink);
  font-weight: 700;
}

.cs-internal-link code {
  color: #087f67;
  color: var(--teal-dark);
  font: 600 10.5px / 1.4 ui-monospace, SFMono-Regular, Consolas, monospace;
  overflow-wrap: anywhere;
  background: #e6f9f4;
  background: var(--teal-soft);
  padding: 2px 6px;
  border-radius: 4px;
}

/* Responsive Media Queries */
@media (max-width: 850px) {
  .cs-report-main {
    width: min(100% - 28px, 720px);
    padding-top: 10px;
  }
  .cs-run-card {
    grid-template-columns: 1fr;
    gap: 13px;
  }
  .cs-run-item + .cs-run-item {
    border-left: 0;
    border-top: 1px solid #e3e3ed;
    border-top: 1px solid var(--line);
    padding: 13px 0 0;
  }
  .cs-report-header,
  .cs-section-head {
    align-items: flex-start;
  }
  .cs-section-note {
    display: none;
  }
  .cs-opportunity {
    grid-template-columns: 38px 1fr;
  }
  .cs-opportunity .cs-action {
    grid-column: 2;
    justify-self: start;
  }
  .cs-change-panel {
    grid-column: 1 / -1;
  }
}

@media (max-width: 580px) {
  .cs-report-header {
    display: block;
  }
  .cs-status {
    margin-top: 14px;
  }
  .cs-gap-summary {
    grid-template-columns: 34px 1fr;
    padding: 14px;
  }
  .cs-summary-side {
    grid-column: 2;
    justify-content: space-between;
  }
  .cs-gap-body {
    padding: 0 14px 15px;
  }
  .cs-compare-grid,
  .cs-change-panel.show,
  .cs-plan-overview,
  .cs-guidance-grid,
  .cs-section-meta {
    grid-template-columns: 1fr;
  }
  .cs-finding {
    grid-template-columns: 1fr;
    gap: 4px;
  }
  .cs-opportunity {
    padding: 15px 14px;
  }
  .cs-internal-link {
    grid-template-columns: 1fr;
    gap: 3px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/content/orbitAi/content-strategy/components/ContentStrategyReport.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;;;EAGE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;;EAEE,4FAA4F;EAC5F,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,cAAuB;EAAvB,uBAAuB;EACvB,mBAA4B;EAA5B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAuB;EAAvB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,cAAS;EAAT,SAAS;EACT,kBAAkB;EAClB,yBAA6B;EAA7B,6BAA6B;EAC7B,mBAA4B;EAA5B,4BAA4B;EAC5B,gBAA0B;EAA1B,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,8BAAkC;EAAlC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAA6B;EAA7B,6BAA6B;EAC7B,kBAAkB;EAClB,cAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;;EAEE,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,yBAA6B;EAA7B,6BAA6B;EAC7B,mBAA4B;EAA5B,4BAA4B;EAC5B,gBAA0B;EAA1B,0BAA0B;EAC1B,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,cAAS;EAAT,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAiB;EAAjB,iBAAiB;EACjB,mBAA2B;EAA3B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAmB;EAAnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAiB;EAAjB,iBAAiB;EACjB,mBAA2B;EAA3B,2BAA2B;AAC7B;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;EACnB,mBAA6B;EAA7B,6BAA6B;AAC/B;;AAEA;EACE,cAAuB;EAAvB,uBAAuB;EACvB,mBAA4B;EAA5B,4BAA4B;AAC9B;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAS;EAAT,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAA6B;EAA7B,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAkB;EAAlB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,cAAS;EAAT,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAAkC;EAAlC,kCAAkC;EAClC,cAAuB;EAAvB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,+CAA+C;EAC/C,cAAS;EAAT,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAuB;EAAvB,uBAAuB;EACvB,mBAA4B;EAA5B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAkB;EAAlB,kBAAkB;EAClB,mBAA4B;EAA5B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;EACnB,mBAA6B;EAA7B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAmB;EAAnB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAuB;EAAvB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAA6B;EAA7B,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,mBAAuB;EAAvB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iFAAiF;EACjF,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,mBAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAkB;EAAlB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAyB;EAAzB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAA6B;EAA7B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAiB;EAAjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,gBAAgB;EAChB,cAAiB;EAAjB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,cAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,cAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAA6B;EAA7B,6BAA6B;EAC7B,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAS;EAAT,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAA6B;EAA7B,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAQ;EAAR,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,cAAS;EAAT,SAAS;EACT,aAAa;EACb,yBAA6B;EAA7B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAuB;EAAvB,uBAAuB;EACvB,mBAA4B;EAA5B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAmB;EAAnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAiB;EAAjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAQ;EAAR,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAmB;EAAnB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAmB;EAAnB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAmB;EAAnB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,aAAQ;EAAR,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,cAAS;EAAT,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAA6B;EAA7B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAuB;EAAvB,uBAAuB;EACvB,wEAAwE;EACxE,uBAAuB;EACvB,mBAA4B;EAA5B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,cAAc;IACd,6BAAiC;IAAjC,iCAAiC;IACjC,iBAAiB;EACnB;EACA;;IAEE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,+BAA+B;EACjC;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,+BAA+B;IAC/B,aAAa;EACf;EACA;IACE,cAAc;IACd,8BAA8B;EAChC;EACA;IACE,oBAAoB;EACtB;EACA;;;;;IAKE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,QAAQ;EACV;EACA;IACE,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,QAAQ;EACV;AACF","sourcesContent":["/* Content Strategy Simplified Report Styles */\n:root,\n.cs-report-root,\n.cs-modal-card {\n  --navy: #14132b;\n  --navy-2: #1d1b3b;\n  --navy-border: #302e54;\n  --teal: #22c9a0;\n  --teal-dark: #087f67;\n  --teal-soft: #e6f9f4;\n  --red: #c53b4a;\n  --red-soft: #fff0f2;\n  --amber: #a96c00;\n  --amber-soft: #fff7e7;\n  --blue: #315fba;\n  --blue-soft: #eef4ff;\n  --ink: #1d1c2e;\n  --muted: #68677c;\n  --quiet: #9291a3;\n  --line: #e3e3ed;\n  --surface: #fff;\n  --canvas: #f6f6fa;\n  --radius: 12px;\n  --shadow: 0 18px 50px rgba(20, 19, 43, 0.16);\n}\n\n.cs-report-root,\n.cs-modal-card {\n  font-family: Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  color: var(--ink);\n}\n\n.cs-report-root {\n  width: 100%;\n}\n\n.cs-report-root *,\n.cs-modal-card * {\n  box-sizing: border-box;\n}\n\n.cs-report-main {\n  padding: 8px 0 60px;\n}\n\n.cs-report-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 18px;\n}\n\n.cs-report-header h1 {\n  margin: 0 0 7px;\n  font-size: clamp(24px, 3vw, 32px);\n  font-weight: 800;\n  letter-spacing: -0.035em;\n  color: var(--ink);\n}\n\n.cs-lede {\n  max-width: 690px;\n  margin: 0;\n  color: var(--muted);\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.cs-status {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 12px;\n  border-radius: 999px;\n  color: var(--teal-dark);\n  background: var(--teal-soft);\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.cs-status::before {\n  content: \"\";\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--teal);\n}\n\n/* Run Card */\n.cs-run-card {\n  display: grid;\n  grid-template-columns: 1.15fr 1.85fr auto;\n  align-items: center;\n  gap: 22px;\n  padding: 16px 18px;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--surface);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.cs-run-item + .cs-run-item {\n  border-left: 1px solid var(--line);\n  padding-left: 22px;\n}\n\n.cs-eyebrow {\n  margin-bottom: 5px;\n  color: var(--quiet);\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n}\n\n.cs-run-value {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.cs-competitors {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.cs-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  border: 1px solid var(--line);\n  border-radius: 6px;\n  color: var(--muted);\n  background: #f9f9fc;\n  font-size: 11px;\n  font-weight: 650;\n}\n\n.cs-run-time {\n  color: var(--muted);\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n/* Sections */\n.cs-section {\n  margin-top: 34px;\n  scroll-margin-top: 20px;\n}\n\n.cs-section-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 20px;\n  margin-bottom: 13px;\n}\n\n.cs-section-title {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.cs-section-title h2 {\n  margin: 0;\n  font-size: 19px;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n  color: var(--ink);\n}\n\n.cs-count {\n  padding: 3px 8px;\n  border-radius: 999px;\n  color: var(--muted);\n  background: #ebebf2;\n  font-size: 11px;\n  font-weight: 750;\n}\n\n.cs-section-copy {\n  margin: 4px 0 0;\n  color: var(--muted);\n  font-size: 13px;\n}\n\n.cs-section-note {\n  max-width: 290px;\n  color: var(--quiet);\n  font-size: 11px;\n  text-align: right;\n  line-height: 1.45;\n}\n\n/* Lists and Cards */\n.cs-gap-list,\n.cs-opportunity-list {\n  display: grid;\n  gap: 12px;\n}\n\n.cs-card {\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--surface);\n  overflow: hidden;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.cs-card:hover {\n  border-color: #d0d0e0;\n}\n\n/* Gap Details & Summary */\n.cs-gap-summary {\n  display: grid;\n  grid-template-columns: 36px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 13px;\n  padding: 17px 18px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.cs-gap-summary:hover {\n  background-color: #fafafd;\n}\n\n.cs-index {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  border-radius: 9px;\n  color: var(--red);\n  background: var(--red-soft);\n  font-size: 11px;\n  font-weight: 850;\n}\n\n.cs-gap-title {\n  margin: 0 0 5px;\n  font-size: 14px;\n  font-weight: 750;\n  color: var(--ink);\n}\n\n.cs-gap-issue {\n  margin: 0;\n  color: var(--muted);\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n\n.cs-summary-side {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.cs-severity {\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.cs-severity.high {\n  color: var(--red);\n  background: var(--red-soft);\n}\n\n.cs-severity.medium {\n  color: var(--amber);\n  background: var(--amber-soft);\n}\n\n.cs-severity.low {\n  color: var(--teal-dark);\n  background: var(--teal-soft);\n}\n\n.cs-chevron {\n  color: var(--quiet);\n  font-size: 16px;\n  transition: transform 0.18s ease;\n  display: inline-block;\n}\n\n.cs-chevron.open {\n  transform: rotate(180deg);\n}\n\n.cs-gap-body {\n  padding: 0 18px 18px 67px;\n  border-top: 1px solid var(--line);\n}\n\n.cs-compare-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin: 15px 0;\n}\n\n.cs-compare {\n  min-width: 0;\n  padding: 13px 14px;\n  border: 1px solid var(--line);\n  border-radius: 9px;\n  background: #fafafd;\n}\n\n.cs-compare.competitor {\n  border-color: #bdeadd;\n  background: #f2fcf9;\n}\n\n.cs-compare-label {\n  margin-bottom: 7px;\n  color: var(--quiet);\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.cs-page-link {\n  display: block;\n  overflow: hidden;\n  margin-bottom: 7px;\n  color: var(--blue);\n  font-size: 11px;\n  text-decoration: none;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.cs-page-link:hover {\n  text-decoration: underline;\n}\n\n.cs-compare p {\n  margin: 0;\n  color: #424156;\n  font-size: 12.5px;\n  line-height: 1.55;\n}\n\n.cs-finding {\n  display: grid;\n  grid-template-columns: 92px 1fr;\n  gap: 12px;\n  margin-top: 10px;\n  font-size: 12.5px;\n  line-height: 1.55;\n}\n\n.cs-finding b {\n  color: var(--muted);\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.cs-finding span {\n  color: var(--ink);\n}\n\n.cs-addressed {\n  margin-top: 14px;\n  padding-top: 13px;\n  border-top: 1px dashed var(--line);\n  color: var(--teal-dark);\n  font-size: 11.5px;\n  font-weight: 700;\n}\n\n/* Opportunities */\n.cs-opportunity {\n  display: grid;\n  grid-template-columns: 42px minmax(0, 1fr) auto;\n  gap: 14px;\n  align-items: start;\n  padding: 18px;\n}\n\n.cs-opportunity .cs-index {\n  color: var(--teal-dark);\n  background: var(--teal-soft);\n}\n\n.cs-opportunity h3 {\n  margin: 1px 0 6px;\n  font-size: 15px;\n  font-weight: 750;\n  line-height: 1.35;\n  color: var(--ink);\n}\n\n.cs-type-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 9px;\n}\n\n.cs-type {\n  padding: 3px 7px;\n  border-radius: 5px;\n  color: var(--blue);\n  background: var(--blue-soft);\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.cs-type.update {\n  color: var(--amber);\n  background: var(--amber-soft);\n}\n\n.cs-type.blog {\n  color: #7651b5;\n  background: #f3effb;\n}\n\n.cs-impact {\n  padding: 3px 7px;\n  border-radius: 5px;\n  color: var(--muted);\n  background: #f1f1f6;\n  font-size: 10px;\n  font-weight: 750;\n}\n\n.cs-opportunity p {\n  margin: 0;\n  max-width: 650px;\n  color: var(--muted);\n  font-size: 12.5px;\n  line-height: 1.55;\n}\n\n.cs-gap-links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 11px;\n}\n\n.cs-gap-ref {\n  color: var(--teal-dark);\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.cs-action {\n  align-self: center;\n  min-width: 142px;\n  padding: 9px 14px;\n  border: 1px solid var(--navy);\n  border-radius: 8px;\n  color: #fff;\n  background: var(--navy);\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 750;\n  text-align: center;\n  transition: transform 0.15s ease, background-color 0.15s ease, opacity 0.15s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.cs-action:hover {\n  transform: translateY(-1px);\n  background: var(--navy-2);\n}\n\n.cs-action:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.cs-action.secondary {\n  color: var(--navy);\n  background: #fff;\n  border-color: #d0d0e0;\n}\n\n.cs-action.secondary:hover {\n  background: #f6f6fa;\n  border-color: var(--navy);\n}\n\n/* Change Panel */\n.cs-change-panel {\n  display: none;\n  grid-column: 2 / -1;\n  margin-top: 8px;\n  padding: 14px;\n  border-radius: 9px;\n  background: #f9f9fc;\n}\n\n.cs-change-panel.show {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 11px;\n}\n\n.cs-change {\n  padding: 11px;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  background: #fff;\n}\n\n.cs-change b {\n  display: block;\n  margin-bottom: 5px;\n  color: var(--quiet);\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-weight: 800;\n}\n\n.cs-change span {\n  font-size: 12px;\n  line-height: 1.45;\n  color: var(--ink);\n  word-break: break-word;\n}\n\n/* AI Page Plan Modal Dialog */\n.cs-modal-card {\n  width: 100%;\n  background: #fff;\n  color: var(--ink);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n}\n\n.cs-modal-head {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n  padding: 20px 22px 15px;\n  border-bottom: 1px solid #e3e3ed;\n  background: #fff;\n}\n\n.cs-modal-head h3 {\n  margin: 4px 0 5px;\n  font-size: 19px;\n  font-weight: 750;\n  color: var(--ink);\n}\n\n.cs-modal-head p {\n  margin: 0;\n  color: var(--muted);\n  font-size: 12px;\n}\n\n.cs-modal-btn {\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 11px;\n  border: 0;\n  border-radius: 8px;\n  color: var(--muted);\n  background: #f1f1f6;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 650;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.cs-modal-btn:hover {\n  background: #e2e2ec;\n  color: var(--ink);\n}\n\n.cs-close-btn {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 8px;\n  color: var(--muted);\n  background: #f1f1f6;\n  cursor: pointer;\n  font-size: 18px;\n  display: grid;\n  place-items: center;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.cs-close-btn:hover {\n  background: #e2e2ec;\n  color: var(--ink);\n}\n\n.cs-modal-body {\n  padding: 20px 22px 24px;\n  overflow-y: auto;\n  max-height: calc(100vh - 140px);\n}\n\n.cs-loading-state {\n  min-height: 280px;\n  display: grid;\n  place-items: center;\n  text-align: center;\n  color: var(--muted);\n  font-size: 13px;\n  padding: 20px;\n}\n\n.cs-spinner {\n  width: 32px;\n  height: 32px;\n  margin: 0 auto 14px;\n  border: 3px solid #e5e4ee;\n  border-top-color: var(--teal);\n  border-radius: 50%;\n  animation: csSpin 0.8s linear infinite;\n}\n\n@keyframes csSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.cs-plan-overview {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.cs-plan-box {\n  padding: 12px 13px;\n  border: 1px solid var(--line);\n  border-radius: 9px;\n  background: #fafafd;\n}\n\n.cs-plan-box b,\n.cs-plan-section > b {\n  display: block;\n  margin-bottom: 5px;\n  color: var(--quiet);\n  font-size: 10px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  font-weight: 800;\n}\n\n.cs-plan-box span {\n  font-size: 12.5px;\n  line-height: 1.45;\n  color: var(--ink);\n}\n\n.cs-plan-section {\n  margin-top: 20px;\n}\n\n.cs-wireframe {\n  display: grid;\n  gap: 9px;\n  margin-top: 10px;\n}\n\n.cs-wire-row {\n  display: grid;\n  grid-template-columns: 32px minmax(0, 1fr);\n  gap: 11px;\n  padding: 14px;\n  border: 1px solid var(--line);\n  border-radius: 9px;\n  background: #fff;\n}\n\n.cs-wire-num {\n  width: 27px;\n  height: 27px;\n  display: grid;\n  place-items: center;\n  border-radius: 7px;\n  color: var(--teal-dark);\n  background: var(--teal-soft);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.cs-wire-row h4 {\n  margin: 0 0 5px;\n  font-size: 13px;\n  font-weight: 750;\n  color: var(--ink);\n}\n\n.cs-wire-row p {\n  margin: 0;\n  color: var(--muted);\n  font-size: 11.5px;\n  line-height: 1.5;\n}\n\n.cs-key-points {\n  margin: 10px 0 0;\n  padding-left: 18px;\n  list-style: disc !important;\n  list-style-type: disc !important;\n}\n\n.cs-key-points li {\n  margin-bottom: 5px;\n  color: var(--ink);\n  font-size: 11.5px;\n  line-height: 1.45;\n  display: list-item !important;\n  list-style: disc !important;\n  list-style-type: disc !important;\n}\n\n.cs-section-meta {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 11px;\n}\n\n.cs-section-detail {\n  padding: 9px 10px;\n  border-radius: 8px;\n  background: #f7f7fa;\n}\n\n.cs-section-detail b {\n  display: block;\n  margin-bottom: 4px;\n  color: var(--quiet);\n  font-size: 9px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  font-weight: 800;\n}\n\n.cs-section-detail span {\n  display: block;\n  color: var(--muted);\n  font-size: 10.5px;\n  line-height: 1.45;\n  overflow-wrap: anywhere;\n}\n\n.cs-guidance-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.cs-guidance-grid ul {\n  margin: 6px 0 0;\n  padding-left: 17px;\n  list-style: disc !important;\n  list-style-type: disc !important;\n}\n\n.cs-guidance-grid li {\n  margin-bottom: 6px;\n  color: var(--muted);\n  font-size: 11.5px;\n  line-height: 1.45;\n  display: list-item !important;\n  list-style: disc !important;\n  list-style-type: disc !important;\n}\n\n.cs-internal-links {\n  display: grid;\n  gap: 7px;\n  margin-top: 10px;\n}\n\n.cs-internal-link {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 12px;\n  align-items: center;\n  padding: 10px 11px;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  background: #fff;\n}\n\n.cs-internal-link strong {\n  font-size: 11.5px;\n  color: var(--ink);\n  font-weight: 700;\n}\n\n.cs-internal-link code {\n  color: var(--teal-dark);\n  font: 600 10.5px / 1.4 ui-monospace, SFMono-Regular, Consolas, monospace;\n  overflow-wrap: anywhere;\n  background: var(--teal-soft);\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n/* Responsive Media Queries */\n@media (max-width: 850px) {\n  .cs-report-main {\n    width: min(100% - 28px, 720px);\n    padding-top: 10px;\n  }\n  .cs-run-card {\n    grid-template-columns: 1fr;\n    gap: 13px;\n  }\n  .cs-run-item + .cs-run-item {\n    border-left: 0;\n    border-top: 1px solid var(--line);\n    padding: 13px 0 0;\n  }\n  .cs-report-header,\n  .cs-section-head {\n    align-items: flex-start;\n  }\n  .cs-section-note {\n    display: none;\n  }\n  .cs-opportunity {\n    grid-template-columns: 38px 1fr;\n  }\n  .cs-opportunity .cs-action {\n    grid-column: 2;\n    justify-self: start;\n  }\n  .cs-change-panel {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 580px) {\n  .cs-report-header {\n    display: block;\n  }\n  .cs-status {\n    margin-top: 14px;\n  }\n  .cs-gap-summary {\n    grid-template-columns: 34px 1fr;\n    padding: 14px;\n  }\n  .cs-summary-side {\n    grid-column: 2;\n    justify-content: space-between;\n  }\n  .cs-gap-body {\n    padding: 0 14px 15px;\n  }\n  .cs-compare-grid,\n  .cs-change-panel.show,\n  .cs-plan-overview,\n  .cs-guidance-grid,\n  .cs-section-meta {\n    grid-template-columns: 1fr;\n  }\n  .cs-finding {\n    grid-template-columns: 1fr;\n    gap: 4px;\n  }\n  .cs-opportunity {\n    padding: 15px 14px;\n  }\n  .cs-internal-link {\n    grid-template-columns: 1fr;\n    gap: 3px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
